import React, { useState, useEffect } from 'react';
import Select from 'react-select-nested-group';
import * as R from 'ramda';
import moment from 'moment';
import toastr from "toastr";
import transform from './observationHelper';
import { Spinner } from '../common/Spinner';
import DateTime from 'react-datetime';

import Things from "../../ducks/Things";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PaginatedTable from '../common/PaginatedTable';


const Observation1Page = (props) => {
  const [selectedVehicle, setSelectedVehicle] = useState('');
  const [things, setThings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableValues, setTableValues] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [selectedHours, setSelectedHours] = useState({ value: 12, label: 12 });

  const data = JSON.parse(localStorage.getItem("companyInfo"));
  const companyId = data.companyId;

  // base columns (always shown)
  const baseColumns = [
    { name: 'Imei', selector: "imei", wrap: true },
    { name: 'Name', selector: "name", wrap: true },
    { name: 'Temperature', selector: "temperature" },
    { name: 'Humidity', selector: "humidity", wrap: true },
    { name: 'Timestamp', selector: "timestamp", wrap: true },
    { name: 'LatLng', selector: "latlng", wrap: true },
    { name: 'GSM_Signal', selector: "GSM_Signal", wrap: true },
    { name: 'GNSS_Status', selector: "GNSS_Status", wrap: true },
    { name: 'External_Voltage', selector: "External_Voltage", wrap: true },
    { name: 'Battery_Voltage', selector: "Battery_Voltage", wrap: true },
    { name: 'Ignition', selector: "Ignition", wrap: true },
    { name: 'Unplug', selector: "Unplug", wrap: true },
    { name: 'Location', selector: "location", wrap: true, width: '500px' },
  ];

  const baseHeaders = [
    { label: 'Imei', key: "imei" },
    { label: 'Name', key: "name" },
    { label: 'Temperature', key: "temperature" },
    { label: 'Humidity', key: "humidity" },
    { label: 'Timestamp', key: "timestamp" },
    { label: 'GSM Signal', key: "GSM_Signal" },
    { label: 'GNSS Status', key: "GNSS_Status" },
    { label: 'External Voltage', key: "External_Voltage" },
    { label: 'Battery Voltage', key: "Battery_Voltage" },
    { label: 'Ignition', key: "Ignition" },
    { label: 'Unplug', key: "Unplug" },
    { label: 'Location', key: "location" },
  ];

  const hoursArray = R.unfold(h => h <= 24 ? [h, h + 1] : false, 1);

  const actions = {
    async onSubmit(event) {
      event.preventDefault();
      if (!selectedVehicle) return toastr.error('Please Select Vehicle.');
      if (!selectedDate) return toastr.error('Start date is required.');
      if (!selectedHours) return toastr.error('Hours selection is required.');

      const endDate = moment(selectedDate).add(selectedHours.value, 'hours');
      const interval = { startDate: moment(selectedDate), endDate: moment(endDate) };

      setIsLoading(true);
      const observations = await props.actions.getObservationsTemp(
        selectedVehicle.value,
        JSON.stringify({ interval })
      );
      setIsLoading(false);

      const values = R.map(transform(selectedVehicle.label))(observations);
      setTableValues(values);
    },

    handleVehicleChange(option) {
      setSelectedVehicle(option);
    },
  };

  const loadThings = async () => {
    setIsLoading(true);
    let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    await props.actions.getGroupVehicles({ groupId: companyInfo.groupId });
    setIsLoading(false);
  };

  useEffect(() => {
    loadThings();
  }, []);

  useEffect(() => {
    const mappedValues = R.map(
      thing => ({ value: thing.imei, label: `${thing.name || 'N/A'}` })
    )(props.things);
    setThings(mappedValues);
  }, [props.things]);

  // 🔑 Build dynamic columns based on sensor flags from API data
  let dynamicColumns = [...baseColumns];
  let dynamicHeaders = [...baseHeaders];

  if (tableValues.some(row => row.enableSensor2)) {
    dynamicColumns.splice(3, 0, 
      { name: 'Temperature 2', selector: "temperature2" },
      { name: 'Humidity 2', selector: "humidity2" }
    );
    dynamicHeaders.splice(3, 0,
      { label: 'Temperature 2', key: "temperature2" },
      { label: 'Humidity 2', key: "humidity2" }
    );
  }

  if (tableValues.some(row => row.enableSensor3)) {
    dynamicColumns.splice(5, 0, 
      { name: 'Temperature 3', selector: "temperature3" },
      { name: 'Humidity 3', selector: "humidity3" }
    );
    dynamicHeaders.splice(5, 0,
      { label: 'Temperature 3', key: "temperature3" },
      { label: 'Humidity 3', key: "humidity3" }
    );
  }

  if (tableValues.some(row => row.enableSensor4)) {
    dynamicColumns.splice(7, 0, 
      { name: 'Temperature 4', selector: "temperature4" },
      { name: 'Humidity 4', selector: "humidity4" }
    );
    dynamicHeaders.splice(7, 0,
      { label: 'Temperature 4', key: "temperature4" },
      { label: 'Humidity 4', key: "humidity4" }
    );
  }

  return !isLoading ? (
    <div>
      <div className="row" style={{ margin: '0px 0px 25px 0' }}>
        <div className="col-lg-3 col-sm-3">
          <label>Select Things</label>
          <Select
            name="form-field-selectedThing"
            value={selectedVehicle}
            searchable={true}
            onChange={actions.handleVehicleChange}
            options={things}
          />
        </div>
        <div className="col-lg-3 col-sm-3">
          <label>Date</label>
          <DateTime
            value={selectedDate}
            dateFormat="DD-MM-YYYY"
            timeFormat="HH:mm"
            onChange={setSelectedDate}
          />
        </div>
        <div className="col-lg-3 col-sm-3">
          <label>Duration (Hours)</label>
          <Select
            name="form-field-name"
            isClearable={false}
            isSearchable={true}
            placeholder="Select"
            defaultValue={selectedHours}
            onChange={setSelectedHours}
            options={hoursArray.map(h => ({ value: h, label: h }))}
          />
        </div>
        <div className="col-lg-3" style={{ padding: '25px 0 0 25px' }}>
          <button
            className={`btn btn-primary search-btn search-button`}
            onClick={actions.onSubmit}
          >
            Search
          </button>
        </div>
      </div>

      <PaginatedTable
        columns={dynamicColumns}
        headers={dynamicHeaders}
        data={tableValues}
        title="Observation List"
        fileName="Observation List"
      />
    </div>
  ) : (
    <div style={{ marginTop: '20%' }}>
      <Spinner />
    </div>
  );
};

const mapStateToProps = state => ({ things: state.things.groupVehicles });
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Things.creators, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(Observation1Page);
